import { render, staticRenderFns } from "./BorderLine.vue?vue&type=template&id=c5f633ca&scoped=true&"
var script = {}
import style0 from "./BorderLine.vue?vue&type=style&index=0&id=c5f633ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f633ca",
  null
  
)

export default component.exports